export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/hamburger-open.2cf6ef50.svg","height":10,"width":16};